'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { DorahartMonogram } from '@/components/brand/DorahartLogo';
import { marcellus } from '@/features/auth/fonts';

const serif = { fontFamily: 'var(--font-marcellus), serif' };

export default function NotFound() {
  const router = useRouter();

  return (
    <div
      className={`${marcellus.variable} fixed inset-0 flex flex-col items-center justify-center overflow-hidden bg-[#fffdfa] px-6 text-center text-[#1a1a1a] antialiased`}
    >
      <DorahartMonogram className='pointer-events-none absolute -bottom-28 -right-28 h-[34rem] text-[#c9a96e]/[0.06]' />

      <div className='relative z-10 flex flex-col items-center'>
        <p className='text-[0.72rem] tracking-[0.36em] text-[#c9a96e] uppercase'>
          Erreur 404
        </p>
        <h1 className='mt-6 text-[3rem] leading-tight text-[#1a1a1a] sm:text-[3.6rem]' style={serif}>
          Page introuvable
        </h1>
        <p className='mt-4 max-w-md text-sm leading-relaxed text-[#1a1a1a]/55'>
          La page que vous cherchez n’existe pas ou a été déplacée.
        </p>

        <div className='mt-10 flex flex-wrap items-center justify-center gap-3'>
          <button
            onClick={() => router.back()}
            className='border border-[#1a1a1a]/20 px-7 py-3.5 text-[0.7rem] tracking-[0.22em] text-[#1a1a1a] uppercase transition-colors hover:border-[#c9a96e] hover:text-[#c9a96e]'
          >
            Retour
          </button>
          <Link
            href='/'
            className='bg-[#1a1a1a] px-7 py-3.5 text-[0.7rem] tracking-[0.22em] text-[#fffdfa] uppercase transition-colors hover:bg-[#c9a96e] hover:text-[#1a1a1a]'
          >
            Accueil
          </Link>
        </div>
      </div>
    </div>
  );
}
